/** @type {import('./index').NetworkConfig} */
const tiktok = {
  name: 'TikTok',
  sort: 2,
  baseUrl: 'https://www.tiktok.com/@',
  domains: ['tiktok.com', 'vt.tiktok.com'],
  supported: true,
  color: '#000000',
  hasVideoContent: true,
  supportsEmbed: true,
  requiresReferrer: false,
  profileUrlPattern: /^https:\/\/(?:www\.)?tiktok\.com\/@([a-zA-Z0-9_.]+)\/?$/,
};

export default tiktok;
